import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Contact form submission
export const submitContactForm = async (formData) => {
  const response = await axios.post(`${API}/contact`, formData);
  return { success: true, message: "Quote request received! Melinda will get back to you within 24 hours.", data: response.data };
};

// Analytics tracking (fire and forget)
export const trackEvent = (eventType, label = '') => {
  axios.post(`${API}/analytics/track`, { eventType, label }).catch(() => {
    // Silent fail - analytics should never break UX
  });
};

// Admin login
export const adminLogin = async (password) => {
  const response = await axios.post(`${API}/admin/login`, { password });
  return response.data;
};

// Get submissions (admin)
export const getSubmissions = async (password) => {
  const response = await axios.get(`${API}/contact/submissions`, {
    headers: { 'X-Admin-Password': password }
  });
  return response.data;
};

// Update submission status (admin)
export const updateSubmissionStatus = async (id, status, password) => {
  const response = await axios.patch(`${API}/contact/submissions/${id}?status=${status}`, {}, {
    headers: { 'X-Admin-Password': password }
  });
  return response.data;
};

// Get analytics summary (admin)
export const getAnalyticsSummary = async (password) => {
  const response = await axios.get(`${API}/analytics/summary`, {
    headers: { 'X-Admin-Password': password }
  });
  return response.data;
};
